


(function() {
    var container = document.querySelector('#au-root .au-hero__image');
    var slides = document.querySelectorAll('#au-root .au-hero__slide');
    var dots = document.querySelectorAll('#au-root .au-hero__dot');
    if (!container || slides.length < 2) return;

    var active = 0;
    var autoplay = null;
    var startX = 0;
    var startY = 0;
    var swipeFired = false;

    function show(index) {
        slides[active].classList.remove('au-hero__slide--active');
        active = (index + slides.length) % slides.length;
        slides[active].classList.add('au-hero__slide--active');
        dots.forEach(function(d, i) {
            d.classList.toggle('au-hero__dot--active', i === active);
        });
    }

    function next() { show(active + 1); }
    function prev() { show(active - 1); }

    function startAutoplay() {
        stopAutoplay();
        autoplay = setInterval(next, 5000);
    }

    function stopAutoplay() {
        if (autoplay) { clearInterval(autoplay); autoplay = null; }
    }

    container.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        swipeFired = false;
        stopAutoplay();
    }, { passive: true });

    container.addEventListener('touchmove', function(e) {
        if (swipeFired) return;
        var dx = e.touches[0].clientX - startX;
        var dy = e.touches[0].clientY - startY;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
            if (dx < 0) next(); else prev();
            swipeFired = true;
        }
    }, { passive: true });

    container.addEventListener('touchend', function() {
        setTimeout(startAutoplay, 3000);
    }, { passive: true });

    var mouseDown = false;
    container.addEventListener('mousedown', function(e) {
        mouseDown = true;
        startX = e.clientX;
        startY = e.clientY;
        swipeFired = false;
        stopAutoplay();
    });
    container.addEventListener('mousemove', function(e) {
        if (!mouseDown || swipeFired) return;
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
            if (dx < 0) next(); else prev();
            swipeFired = true;
        }
    });
    container.addEventListener('mouseup', function() {
        mouseDown = false;
        setTimeout(startAutoplay, 3000);
    });
    container.addEventListener('mouseleave', function() {
        if (mouseDown) { mouseDown = false; setTimeout(startAutoplay, 3000); }
    });

    dots.forEach(function(dot, i) {
        dot.addEventListener('click', function(e) {
            e.stopPropagation();
            stopAutoplay();
            show(i);
            setTimeout(startAutoplay, 3000);
        });
    });

    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) startAutoplay();
})();
